<template>
  <div class="relative group">
    <ui-link
      :key="item.text"
      :to="{path: item?.to}"
      class="hover:!underline"
      :text="t(item.text)"
      :svg="item?.children?.length ? 'fas fa-chevron-down' : ''"
      class-svg="!px-1 lg:!px-2 -mx-1 group-hover:rotate-180 group-hover:pt-1 group-hover:-mt-px"
      :iconleft="true"
      />
    <!--  -->

    <div class="hidden group-hover:block absolute top-full pt-2">
      <div class="ui-flyout-card">
        <div
          v-for="(child,i) in item?.children?.filter((x:any) => x.auth === null || x.auth === isAuthed)"
          :key="'navchild_'+item.text+'_'+i"
          class="hover:bg-gray-100 !my-0 group/child relative"
          >
          <ui-link
            :to="child?.to"
            :svg="child?.svg"
            :class-svg="[child?.svgClass,'text-secondary text-[13px] w-6 text-center']"
            :iconleft="true"
            class="inline-flex py-[10px] px-5 w-full !line-clamp-1 truncate"
            :class="{
              'border-b border-gray-200/60': i !== item.children.length - 1,
            }"
            >
            <span v-text="t(child.text)" />
            <i v-if="child?.children?.length" class="inline-block flex-grow text-right fas fa-chevron-right ml-4 text-xs text-gray-400" />
          </ui-link>
          <div class="hidden group-hover/child:block ui-flyout-card absolute left-full top-0 z-[500]">
            <div
              v-for="(subchild,j) in child?.children?.filter((x:any) => x.auth === null || x.auth === isAuthed)"
              :key="'navsubchild_'+child.text+'_'+j"
              class="hover:bg-gray-100 !my-0"
              >
              <ui-link
                :to="subchild?.to"
                :text="t(subchild.text)"
                :svg="subchild?.svg"
                :class-svg="[subchild?.svgClass,'text-secondary text-[13px] w-6 text-center']"
                :iconleft="true"
                class="inline-flex py-[10px] px-5 w-full !line-clamp-1 truncate"
                :class="{
                  'border-b border-gray-200/60': j !== child.children.length - 1,
                }"
                />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n()
const {item} = defineProps<{
  item: any
}>()
</script>
